import {
  List,
  ListItem,
  ListItemIcon,
  Divider,
  Menu,
  MenuItem,
  Slider,
  Popover,
  Backdrop,
  CircularProgress,
} from "@mui/material";
import React, { useEffect, useRef, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useMediaQuery } from "@mui/material";
import typeofvisit from "../../assets/tasks/ic_outline-contact-support.svg";
import diagnosisicon from "../../assets/tasks/material-symbols-light_diagnosis-outline.svg";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSearch } from "@fortawesome/free-solid-svg-icons";
import DiagnosisPopup from "../../orders/popups/diagnosispopup";
import api from "../../api/api";
import { useDispatch, useSelector } from "react-redux";
import { setSearchResults } from "../../reduxtoolkit/orders/universalsearch";
import {
  updatelov2Value,
  updatelovValue,
  updateTov2Value,
  updateTovValue,
} from "../../reduxtoolkit/dump";
import CloseIcon from '@mui/icons-material/Close';
import {
  convertDateTimeToCustomFormat,
  formattedDob,
} from "../../utils/dateutils/dateutility";
import ToastMessage from "../../utils/mui/righttoptoast";
import AddIcon from "@mui/icons-material/Add";
import Level from "../../../src/assets/orders/Level.svg";
import Fallowup from "../../../src/assets/orders/Fallowup.svg";
import CustomDropdown from "./CustomDropdown";
import dayjs from "dayjs";
import "../../orders/orders.css";
import { getPracticeId, patientPhotoUrl } from "../../config/practice";

const FALLBACK_PHOTO =
  "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAOEAAADhCAMAAAAJbSJIAAAAM1BMVEXk5ueutLeqsbTn6eqpr7PJzc/j5ebf4eLZ3N2wtrnBxsjN0NLGysy6v8HT1tissra8wMNxTKO9AAAFDklEQVR4nO2d3XqDIAxAlfivoO//tEOZWzvbVTEpic252W3PF0gAIcsyRVEURVEURVEURVEURVEURVEURVEURVEURVEURflgAFL/AirAqzXO9R7XNBVcy9TbuMHmxjN6lr92cNVVLKEurVfK/zCORVvW8iUBnC02dj+Wpu0z0Y6QlaN5phcwZqjkOkK5HZyPAjkIjSO4fIdfcOwFKkJlX4zPu7Ha1tIcwR3wWxyFhRG6g4Je0YpSPDJCV8a2Sv2zd1O1x/2WMDZCwljH+clRrHfWCLGK8REMiql//2si5+DKWKcWeAGcFMzzNrXC/0TUwQ2s6+LhlcwjTMlYsUIQzPOCb7YBiyHopyLXIEKPEkI/TgeuiidK/R9FniUDOjRDpvm0RhqjMyyXNjDhCfIMYl1gGjIMIuYsnGEYRMRZOMMunaLVwpWRW008v6fYKDIzxCwVAeNSO90BJW6emelYBRF/kHpYGVaoxTDAaxOFsfP9y8hpJ4xd7gOcij7JNGQ1EYFgkPJa1jQEiYZXRaRINKxSDUW9n+FT82lSKadkiru9/4XPqSLWOekGPoY05TAvLm9orm+YWuwHoBHkZKijNBJGmeb61eL6Ff/6q7bLr7yvv3vKGhpDRjvgjGaPz+gUg6YgcvpyAR2FIZ9U6nEEyZRTovmEU32KichpGn7C17XrfyH9gK/c0CMP05HZIM2uf9sEveizKveBy9/6Qt7o89ne33D525cfcIMW6ab+TMEukQbQbu+xu7X3A9bChmWaCeAkG17bpntwXgWxHaMzGPmUaR5dQZiKqRVeUZ3047fi3nAu28h4CHxCsZAgmEH8Y27jJAhm8c+5RQzRQNVGhVFSfxOYIjp/pP7RxzjevYXVGf4eLt+BJ1vCuLuLkrgABgCGXZ2wik5uty+oBvNirI6mkzhAf4Gsb58Hcm67Jzd+KwD10BYPLL3e0MjvKrgAULnOfveF/O4N2Xb9BZom3gJes3F9X5Zze8/6Yt09b4CrqsEjUv8oFBaR2rl+6CZr2xVrp24o/WitBKuGrrpl1+bFkmK2qXTON4VpbdfLa7o7y/WdLxG7lm2Lqh2clOwTegbvc/vj2U78CwhA87Bn8G5Nk3eOb0Nsr9flz3sG78UUtue4kpv1xvjg3TMay62BMlTlP+vrOMnJsRmt/ze0jsfkPPYdAH57hK+34PeOyc8XIXu5xT2HsUkdZz+adwg8HGFfQ3K5jtDvbUiO4Di9/ywHGrL88pDizZ++oTp+an+SMX/ndymUCwmHMdO7yuOx83pUx/eEMU0AvxWndwgidAqOZ8ypCwdEfvvEo6D9HwpA8wzvmOJEqAg9ySu8g4x0Hb9hSB/BANEKJ+LbPBU0lzbAJs4xt1AoshKkUGQmiH8/jJ0gdhTTLmSegHlPE0oOdXALnqDjKYh3px//fSgSWG8UqfrrIICzYYSJXRr9BSPbpNzw7gBjKjKOYI7ReIGqQRIap5+5MdjyvuDkExvGeXSlONWZAP3/AZBwJohU7QJRGU+cTVH18ELmRPNBmibW6MT/k1b0XhdkRBvyT6SB6EYv/GvhSmRNpGngRULsAlxMCGNXp7w3FfdEbTEEDdLI9TdIKRUzUesa3I461ER8cpNT7gMRhpKmYVS9ELOgCUQsa4SsulciKiLbY+AnHD8cpuhISsnxpamI84sbDq9qYJgf8wiiOBrC7Ml7M7ZECCqKoiiKoiiKoiiKoijv5AvJxlZRyNWWLwAAAABJRU5ErkJggg==";

const OrdersSideNav = ({ isCollapsed, setIsCollapsed, tab, setTab, data, onBack, backLabel }) => {
  const percentage = 100;
  const { id, dt } = useParams();
  const miniSidenav = isCollapsed;
  const isMobile = useMediaQuery("(max-width: 768px)");
  const circleStyle = {
    ...(data?.deductiblemet && { backgroundColor: `#${data.deductiblemet}` }),
  };
  const[isLoading,setLoading]=useState(false)
  const [diagnosispopup, setisDiagnosisPopup] = useState(false);
  const [selectedOption, setSelectedOption] = useState("");
  const [extraAnchorEl, setExtraAnchorEl] = useState(null);
  const extraOpen = Boolean(extraAnchorEl);
  const handleOpenExtra = (e) => setExtraAnchorEl(e.currentTarget);
  const handleCloseExtra = () => setExtraAnchorEl(null);
  const [showExtraTovLov, setShowExtraTovLov] = useState(false); // State to toggle extra tov/lov
  const angle = percentage * 3.6; // In degrees
  const radians = (angle - 90) * (Math.PI / 180); // Convert to radians
  const radius = 35; // Radius of the ring
  const smallCircleOffset = 8; // Offset for small circle
  const [universalSearch, setUniversalSearch] = useState("");
  const appointmentInfo = useSelector((state) => state.appinfo.appointmentInfo);
  const dispatch = useDispatch();
  const debounceTimeoutRef = useRef(null);
  const [alertmessage, setAlertMessage] = useState("");
  const [severity, setSeverity] = useState("success");
  
  const [open, setOpen] = useState(false);
  const practiseid = getPracticeId();
  const [initialData, setInitialData] = useState([]);
  const smallCircleStyle = {
    position: "absolute",
    top: `${60 + radius * Math.sin(radians) - smallCircleOffset}px`,
    left: `${60 + radius * Math.cos(radians) - smallCircleOffset}px`,
    width: "28px",
    height: "28px",
    backgroundColor: "#FFFFFF",
    borderRadius: "50%",
    transform: "translate(-50%, -50%)",
    boxShadow: "0px 4px 4px 0px rgba(0, 0, 0, 0.25)",
  };

  const handlealert = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpen(false);
  };

  React.useEffect(() => {
    setIsCollapsed(isMobile);
  }, [isMobile]);

  const lovValue = useSelector(
    (state) => state.dump.storedvalues.find((item) => item.id === "lov")?.value
  );
  const tovValue = useSelector(
    (state) => state.dump.storedvalues.find((item) => item.id === "tov")?.value
  );
  const lov2Value = useSelector(
    (state) => state.dump.storedvalues.find((item) => item.id === "lov2")?.value
  );
  const tov2Value = useSelector(
    (state) => state.dump.storedvalues.find((item) => item.id === "tov2")?.value
  );

  const handleCollapse = () => {
    setIsCollapsed((prev) => !prev);
  };

  const handletabs = (e) => {
    if (e === 8) return;
    setTab(e);
  };

  const handleChange = (newValue) => {
    const numericValue = Number(newValue);
    dispatch(updatelovValue(numericValue));
  };

  const handletovChange = (newValue) => {
    dispatch(updateTovValue(newValue));
    setSelectedOption(newValue);
  };

  const handleChange2 = (newValue) => {
    const numericValue = Number(newValue);
    dispatch(updatelov2Value(numericValue));
  };

  const handletov2Change = (newValue) => {
    dispatch(updateTov2Value(newValue));
  };
useEffect(()=>{
if(tovValue!==selectedOption){
setSelectedOption(tovValue)
}
},[tovValue])
const updatelov2api=async()=>{
  try {
    setLoading(true)
   const response= await api.delete(
            `/v1/${practiseid}/orders/delete/patient/${data.patientid}/secondtovtask`,{
           data: {
              task: "VISIT",
              orderdate:
        data?.startdate &&
data?.startdate.includes(" ") &&
dayjs(data?.startdate.split(" ")[0], "YYYY-MM-DD", true).isValid()
  ? dayjs(data?.startdate.split(" ")[0]).format("YYYY-MM-DD")
  : dayjs().format("YYYY-MM-DD"),
              lov2: 0,
              tov2: '',
            }}
          )
          if(response.status==200){
            
            
              //  updatedashboard()
                  
        //         setToastSeverity("success");
        // setToastMessage(response?.message || "Type of Visit Updated Successfully");
        // setOpenToast(true);
          }else{
        //         setToastSeverity("info");
        // setToastMessage(response?.message || "Something Went Wrong");
        // setOpenToast(true);
          }
  } catch (error) {
    console.log(error)
      // setToastSeverity("error");
      //   setToastMessage("Something Went Wrong");
      //   setOpenToast(true);
  }finally{
setLoading(false)
  }
}
  const fetchData = async () => {
    try {
      const response = await api.get(
        `/v1/${practiseid}/orders/patient/${appointmentInfo?.patientid}/condition`
      );
      if (response.status === 200) {
        setInitialData(response.pConditions);
      }
    } catch (error) {
      console.error("Error fetching patient conditions:", error);
    }
  };

  // DIAGNOSIS shows what is saved on THIS visit (appointment_master.diagnosis
  // via get-orders), not the patient problem list, and reloads after a save:
  // otherwise a saved diagnosis never appears here and looks unsaved.
  const [visitDx, setVisitDx] = useState([]);
  const fetchVisitDx = async () => {
    const a = appointmentInfo;
    if (!a?.patientid || !a?.appointmentid) { setVisitDx([]); return; }
    try {
      const res = await api.post(`/v1/${practiseid}/orders/patient/${a.patientid}/get-orders`, {
        appointmentid: a.appointmentid,
        orderdate: String(a.startdate || "").split(" ")[0] || dayjs().format("YYYY-MM-DD"),
      });
      setVisitDx(res?.status === 200 ? res?.data?.diagnosis || [] : []);
    } catch (error) {
      console.error("Error fetching visit diagnoses:", error);
    }
  };
  useEffect(() => {
    fetchData();
    fetchVisitDx();
  }, [appointmentInfo?.patientid, appointmentInfo?.appointmentid]);

  const handlediagnosis = () => {
    setisDiagnosisPopup(true);
  };

  const navItems = [{ label: "DIAGNOSIS", id: 8, badge: 8, icon: "DX" }];

  const [anchorEl, setAnchorEl] = useState(null);
  const [menuIndex, setMenuIndex] = useState(null);

  const handleMenuClick = (event, index) => {
    setAnchorEl(event.currentTarget);
    setMenuIndex(index);
  };

  // Options for Type of Visit, excluding the selected tovValue for tov2
  const tovOptions = [
    "New Patient",
    "Follow up",
    "Consultation",
    "Wellness Commercial",
    "Wellness Medicare",
    "Others",
    "Nurse Visit",
    "Labs",
  ].filter((option) => option !== tovValue);

  const collapseButton = (
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="32"
                height="32"
                viewBox="0 0 48 48"
                fill="none"
              >
                <g filter="url(#filter0_d_787_7715)">
                  <circle
                    cx="24"
                    cy="24"
                    r="16"
                    transform="rotate(-180 24 24)"
                    fill="#E17954"
                  />
                </g>
                <foreignObject
                  x="16.5"
                  y="9"
                  width="15"
                  height="30"
                  style={{ cursor: "pointer" }}
                >
                  {miniSidenav ? (
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="15"
                      height="30"
                      viewBox="0 0 15 30"
                      fill="none"
                    >
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M12.6962 15.8887L5.62492 22.96L3.85742 21.1925L10.0449 15.005L3.85742 8.81749L5.62492 7.04999L12.6962 14.1212C12.9305 14.3556 13.0622 14.6735 13.0622 15.005C13.0622 15.3364 12.9305 15.6543 12.6962 15.8887Z"
                        fill="white"
                      />
                    </svg>
                  ) : (
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="15"
                      height="30"
                      viewBox="0 0 15 30"
                      fill="none"
                    >
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M2.30383 14.1113L9.37508 7.04001L11.1426 8.80751L4.95508 14.995L11.1426 21.1825L9.37508 22.95L2.30383 15.8788C2.06949 15.6444 1.93785 15.3265 1.93785 14.995C1.93785 14.6636 2.06949 14.3457 2.30383 14.1113Z"
                        fill="white"
                      />
                    </svg>
                  )}
                </foreignObject>
                <defs>
                  <filter
                    id="filter0_d_787_7715"
                    x="0"
                    y="0"
                    width="48"
                    height="48"
                    filterUnits="userSpaceOnUse"
                    colorInterpolationFilters="sRGB"
                  >
                    <feFlood floodOpacity="0" result="BackgroundImageFix" />
                    <feColorMatrix
                      in="SourceAlpha"
                      type="matrix"
                      values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                      result="hardAlpha"
                    />
                    <feOffset />
                    <feGaussianBlur stdDeviation="4" />
                    <feComposite in2="hardAlpha" operator="out" />
                    <feColorMatrix
                      type="matrix"
                      values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
                    />
                    <feBlend
                      mode="normal"
                      in2="BackgroundImageFix"
                      result="effect1_dropShadow_787_7715"
                    />
                    <feBlend
                      mode="normal"
                      in="SourceGraphic"
                      in2="effect1_dropShadow_787_7715"
                      result="shape"
                    />
                  </filter>
                </defs>
              </svg>
  );
  const levelHints = {
    1: "Minimal",
    2: "Straightforward",
    3: "Low complexity",
    4: "Moderate complexity",
    5: "High complexity",
  };
  const dobText = data?.dob && dayjs(data.dob).isValid()
    ? dayjs(data.dob).format("MMM D, YYYY")
    : formattedDob(data?.dob);
  const BackArrow = (
    <svg fill="none" stroke="currentColor" strokeWidth="2.2" viewBox="0 0 24 24" aria-hidden="true">
      <polyline points="15 18 9 12 15 6" />
    </svg>
  );
  const PlusGlyph = (
    <svg fill="none" stroke="currentColor" strokeWidth="2.2" viewBox="0 0 24 24" aria-hidden="true">
      <path d="M12 5v14M5 12h14" />
    </svg>
  );
  const isOfficeVisit =
    tovValue?.includes("New Patient") ||
    tovValue?.includes("Follow up") ||
    tovValue?.includes("Consultation");
  const isWellness =
    tovValue?.includes("Wellness Commercial") || tovValue?.includes("Wellness Medicare");

  return (
    <>
      <div
        className={`bmos-rail fixed z-50 left-0 h-[100%] bg-[white] border-r border-[#E7EAF0] transition-all ${
          miniSidenav ? "mini" : ""
        }`}
      >
        <div className={`bmos${miniSidenav ? " mini" : ""}`}>
          <div className="bmos-top">
            {onBack && (
              <button type="button" className="bmos-back" onClick={onBack} title={backLabel}>
                {BackArrow}
                {!miniSidenav && backLabel}
              </button>
            )}
            <div onClick={handleCollapse} style={{ cursor: "pointer", flex: "none" }}>
              {collapseButton}
            </div>
          </div>

          {miniSidenav ? (
            <div className="flex flex-col gap-3 w-full items-center mt-4">
              <img
                src={patientPhotoUrl(data?.patientid)}
                alt="profile"
                className="bmos-photo"
                style={{ width: 40, height: 40, "--ring": data?.deductiblemet ? `#${data.deductiblemet}` : "transparent" }}
                onError={(e) => (e.target.src = FALLBACK_PHOTO)}
              />
              <div
                className="flex items-center font-inter text-xs text-[#1E2A4A] cursor-pointer"
                onClick={handlediagnosis}
              >
                DX
              </div>
              <img
                onClick={() => setIsCollapsed(!isCollapsed)}
                src={Fallowup}
                className="cursor-pointer"
                style={{ width: "20px" }}
                alt="Type of visit"
              />
              <img
                onClick={() => setIsCollapsed(!isCollapsed)}
                src={Level}
                className="cursor-pointer"
                style={{ width: "20px" }}
                alt="Level of visit"
              />
            </div>
          ) : (
            <>
              <div className="bmos-patient">
                {/* The ring keeps the coverage colour (deductiblemet) the old
                    photo frame carried. */}
                <img
                  src={patientPhotoUrl(data?.patientid)}
                  alt="profile"
                  className="bmos-photo"
                  style={{ "--ring": data?.deductiblemet ? `#${data.deductiblemet}` : "transparent" }}
                  onError={(e) => (e.target.src = FALLBACK_PHOTO)}
                />
                <div style={{ minWidth: 0 }}>
                  <div className="bmos-name">
                    {`${data?.firstname || ""} ${data?.lastname || ""}`.trim()}{" "}
                    {/* A real space before it, so a long name lets the number wrap with it. */}
                    <span className="bmos-id">#{data?.patientid}</span>
                  </div>
                  {dobText && (
                    <div className="bmos-row">
                      <span className="bmos-row-k">DOB</span>
                      {dobText}
                    </div>
                  )}
                  {data?.insurancename && (
                    <div className="bmos-row">
                      <span className="bmos-row-k">Ins</span>
                      {data.insurancename}
                    </div>
                  )}
                </div>
              </div>

              <div className="bmos-section">
                <div className="bmos-label">
                  Diagnosis
                  <span className="bmor-count">{visitDx.length}</span>
                  <button
                    type="button"
                    className="bmos-add"
                    title="Add diagnosis"
                    aria-label="Add diagnosis"
                    onClick={handlediagnosis}
                  >
                    {PlusGlyph}
                  </button>
                </div>
                {visitDx.length > 0 ? (
                  <div className="bmos-dx">
                    {visitDx.map((condition) => (
                      <div key={condition.icd10 || condition.id} className="bmos-dx-row">
                        {condition.icd10 && <span className="bmos-icd">{condition.icd10}</span>}
                        <span className="bmos-dx-name">{condition.condition_name}</span>
                      </div>
                    ))}
                  </div>
                ) : (
                  <div className="bmos-empty">No diagnoses on this visit.</div>
                )}
              </div>

              <div className="bmos-section">
                <div className="bmos-label">Type of visit</div>
                <select
                  className="bmos-select"
                  value={selectedOption || ""}
                  onChange={(e) => handletovChange(e.target.value)}
                >
                  <option value="" disabled>
                    Select a visit
                  </option>
                  {[
                    "New Patient",
                    "Follow up",
                    "Consultation",
                    "Wellness Commercial",
                    "Wellness Medicare",
                    "Others",
                    "Nurse Visit",
                    "Labs",
                  ].map((o) => (
                    <option key={o} value={o}>
                      {o}
                    </option>
                  ))}
                </select>
              </div>

              {isOfficeVisit && (
                <div className="bmos-section">
                  <div className="bmos-label">Level of visit</div>
                  <div className="bmos-levels">
                    {[1, 2, 3, 4, 5].map((value) => (
                      <button
                        key={value}
                        type="button"
                        className={`bmos-level${lovValue === value ? " on" : ""}`}
                        aria-pressed={lovValue === value}
                        onClick={() => handleChange(value)}
                      >
                        {value}
                      </button>
                    ))}
                    <button
                      type="button"
                      className="bmos-level more"
                      title="Add a second visit type"
                      aria-label="Add a second visit type"
                      onClick={handleOpenExtra}
                    >
                      {PlusGlyph}
                    </button>
                  </div>
                  {levelHints[lovValue] && (
                    <div className="bmos-level-hint">
                      Level {lovValue} · {levelHints[lovValue]}
                    </div>
                  )}
                </div>
              )}

              {isWellness && (
                <div className="bmos-section">
                  <div className="bmos-label">Level of visit</div>
                  <select
                    className="bmos-select"
                    value={lovValue}
                    onChange={(e) => handleChange(e.target.value)}
                  >
                    <option value="1">First</option>
                    <option value="2">Subsequent</option>
                  </select>
                </div>
              )}

              {tov2Value && (
                <div className="bmos-second">
                  {tov2Value}
                  <span className="ml-1 flex items-center justify-center w-5 h-5 rounded-full bg-[#E17954] text-white text-xs font-bold">
                    {lov2Value || "-"}
                  </span>
                  <CloseIcon
                    className="cursor-pointer text-[#E17954]"
                    style={{ fontSize: "16px" }}
                    onClick={() => {
                      dispatch(updateTov2Value(null));
                      dispatch(updatelov2Value(null));
                      updatelov2api();
                    }}
                  />
                </div>
              )}
            </>
          )}
        </div>

        <Popover
          open={extraOpen}
          anchorEl={extraAnchorEl}
          onClose={handleCloseExtra}
          anchorOrigin={{ vertical: "center", horizontal: "right" }}
          transformOrigin={{ vertical: "top", horizontal: "left" }}
          PaperProps={{
            sx: {
              p: 2,
              width: 260,
              borderRadius: 2,
              boxShadow: "0px 8px 24px rgba(0,0,0,0.12)",
              position: "relative",
              overflow: "visible", // <- allow dropdown to spill out
            },
          }}
        >
          <div className="text-[13px] font-medium text-[#7E7E7E] mb-2">Type Of Visit</div>
          <CustomDropdown
            options={tovOptions
              .filter((o) => o === "Wellness Commercial" || o === "Wellness Medicare")
              .map((o) => ({ value: o, label: o }))}
            value={tov2Value}
            onChange={handletov2Change}
            placeholder="Select Type"
          />

          <div className="text-[12px] font-semibold text-[#1E2A4A] mb-1">Level of Visit</div>
          <CustomDropdown
            options={[
              { value: "1", label: "First" },
              { value: "2", label: "Subsequent" },
            ]}
            value={lov2Value}
            onChange={handleChange2}
          />
        </Popover>
      </div>
      <ToastMessage
        message={alertmessage}
        severity={severity}
        open={open}
        handleClose={handlealert}
      />
      <Backdrop
        sx={{
          color: "#fff",
          zIndex: (theme) => theme.zIndex.drawer + 1,
          backgroundColor: "rgba(0, 0, 0, 0.7)", // reduced opacity (default is 0.5)
        }}
        open={isLoading}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      <DiagnosisPopup
        appid={appointmentInfo}
        setAlertMessage={setAlertMessage}
        setSeverity={setSeverity}
        setOpen={setOpen}
        isOpen={diagnosispopup}
        onClose={() => setisDiagnosisPopup(false)}
        onSaved={() => fetchVisitDx()}
      />
    </>
  );
};

export default OrdersSideNav;
